import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';
import { BundleUpdateApiModel } from './bundle-update.api-model';
import {
  BundleUpdateCheckResponse,
  BundleUpdateStatusResponse,
  BundleUpdateVerifyGateway,
} from './bundle-update.model';
import { GenericDataResponse } from '../analytics/analytics.model';

@Injectable()
export class BundleUpdateApi implements BundleUpdateApiModel {
  private readonly baseUrl = 'iot/v3/bundle-update/update';

  constructor(private clientService: ClientService) {}

  /**
   * check update verification of firmware update
   * @param gatewaySerial
   */
  checkUpdateVerification(
    gatewaySerial: string,
    salesForceCaseNumber?: string
  ): Observable<BundleUpdateCheckResponse> {
    let endpoint = `${this.baseUrl}/check/${gatewaySerial}`;
    if (salesForceCaseNumber) {
      endpoint += `?salesForceCaseNumber=${salesForceCaseNumber}`;
    }

    return this.clientService.post(endpoint, {});
  }

  /**
   * check installation process
   * @param gatewaySerial
   */
  checkOverallProgress(gatewaySerial: string): Observable<BundleUpdateStatusResponse> {
    const endpoint = `${this.baseUrl}/status/${gatewaySerial}`;

    return this.clientService.get(endpoint);
  }

  checkUpdateFirmwareVerification(
    gatewaySerial: string,
    salesForceCaseNumber?: string
  ): Observable<BundleUpdateCheckResponse> {
    let endpoint = `${this.baseUrl}/trigger/${gatewaySerial}`;
    if (salesForceCaseNumber) {
      endpoint += `?salesForceCaseNumber=${salesForceCaseNumber}`;
    }

    return this.clientService.post(endpoint, {});
  }

  verifyGateway(gatewaySerial: string): Observable<GenericDataResponse<BundleUpdateVerifyGateway>> {
    const endpoint = `iot/v3/bundle-update/update/validate/${gatewaySerial}/VGW`;

    return this.clientService.get(endpoint);
  }
}
